import React from 'react';
import { MenuButton, ListItem } from 'react-md';
import { IMAGES_BASE_URL } from '../../../settings';

const SeatingArrangementSelect = ({ seatingArrangement, seatingSVG, seatingText, handleMenuClick, label }) => {
  const seatingList =
    (seatingArrangement[0]?.seatArrangement &&
      seatingArrangement.map((item) => {
        return {
          name: item?.seatArrangement?.name,
          svg: `${IMAGES_BASE_URL}${item?.seatArrangement?.icon}`,
        };
      })) ||
    [];

  const nodeList =
    seatingList.length &&
    seatingList.map((seating) => (
      <ListItem className="seating-menu-wrapper" onClick={() => handleMenuClick(seating.name, seating.svg)}>
        <span className="title">{seating.name}</span>
        <img src={seating.svg} className="img" alt={seating.name} />
      </ListItem>
    ));
  const seatingPlaceholder = [<span className="light-gray"></span>];
  return (
    <>
      <MenuButton flat primary position={MenuButton.Positions.BOTTOM_LEFT} menuItems={nodeList} label={label}></MenuButton>
      <div className="select-item-wrapper">
        <span className="title">{seatingText ? seatingText : seatingPlaceholder}</span>
        {seatingSVG && <img src={seatingSVG} className="img" alt={seatingText} />}
      </div>
    </>
  );
};

export default SeatingArrangementSelect;
